import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faLink } from '@fortawesome/pro-light-svg-icons'

import { snakeToTitleCase } from '@domain-group/javascript-utils'

import { Box, ListItem, Text } from '@domain-group/suit-theme'

import useIntegration from '@hooks/useIntegration'

import type { AgencyModel, IntegrationModel } from '@models/types'

import IntegrationPlatformLogo from '@components/IntegrationPlatformLogo'

interface IntegrationModuleProps {
  agency: AgencyModel,
  integration: IntegrationModel,
}

const IntegrationModule = (props: IntegrationModuleProps) => {
  const { agency, integration: initIntegration } = props

  const integrationPayload = useIntegration(initIntegration)

  const disabledIntegrationModules = agency?.options?.disabled_integration_modules || []
  // @ts-expect-error TS2345
  const disabled = disabledIntegrationModules?.includes('third_party_integration')

  const {
    callbacks: { createOrEditIntegration },
    integration,
  } = integrationPayload

  const { service_provider } = integration

  return (
    <Box variant="white" marginBottom="large" flexDirection="column">
      <Box alignItems="center">
        <IntegrationPlatformLogo
          integrationPlatformKey="my_property_pass"
          imageProps={{
            backgroundSize: 'contain',
            height: 68,
            width: 100,
          }}
        />

        <ListItem
          boxProps={{
            border: '1px solid',
            borderTop: 0,
            borderRight: 0,
            padding: 'large',
            alignItems: 'center',
          }}
          disableHover
        >
          <Box flexDirection="column" justifyContent="center">
            <Text fontSize="small">{snakeToTitleCase(service_provider)}</Text>

          </Box>
        </ListItem>
      </Box>

      <Box borderTop="1px solid" borderColor="lineColor" flexDirection="column" maxHeight={300} overflow="auto">
        <ListItem
          boxProps={{
            as: 'a',
            alignItems: 'center',
            borderBottom: '1px dashed',
            padding: 'large',
          }}
          disableHover={disabled}
          onClick={() => (disabled ? null : createOrEditIntegration())}
          showAngleIcon={!disabled}
        >
          <Box>
            <Text color="bodyFontLightColor" fontSize="small" lineHeight="1.3">
              <FontAwesomeIcon icon={faLink} />
            </Text>

            <Text color="bodyFontLightColor" fontSize="small" lineHeight="1.3" marginLeft="medium">
              {agency.title}
            </Text>
          </Box>
        </ListItem>
      </Box>
    </Box>
  )
}

export default IntegrationModule
